<template>
  <tour :steps="tourSteps">
    <div class="content-wrapper">
      <div id="vaccination-list">
        <PageHeader screenName="Logs e Reprocessamento" :linkItems="linkItems"/>

        <div class="card pt-2">
          <main>
            <IntegracaoRndsFiltros
              :search.sync="search"
              :loading="loading"
              :departamentoSelect="departamentoSelect"
              :campanhaSelect="campanhaSelect"
              :unidadeSelect="unidadeSelect"
              :empresaSelect="empresaSelect"
              :vacinaSelect="vacinaSelect"
              :dosesSelect="dosesSelect"
              :situacaoSelect="situacaoSelect"
              :inconsistenciasSelect="inconsistenciasSelect"
              :tipoAcaoSelect="tipoAcaoSelect"
              :pageSize="paginationData.defaultSize"
              :pageSizeOptions="table.optionsSize"
              @search="validateAndFilterList"
              @clean="cleanSearch"
              @export-csv="validateAndDownloadCSV"
              @page-size-change="changePageSize"
              ref="filtrosComponent"
            />

            <hr class="mx-1 mb-1">

            <IntegracaoRndsAcoes
              :contagemRegistrosComErro="contagemRegistrosComErro"
              :selectedCount="selectedCount"
              :filtering="filtering"
              @reprocessar-todos-erro="reprocessarTodosComErro"
              @reprocessar-selecionados="reprocessarSelecionados"
            />
          </main>

          <IntegracaoRndsTabela
            v-if="!loadingData"
            :items="table.items"
            :filtering="filtering"
            :paginationData="paginationData"
            :selectAll.sync="selectAll"
            :sortBy.sync="table.columnOrder"
            :sortDesc.sync="table.sortDesc"
            @sort-changed="ordenarColuna"
            @page-change="updateCurrentPage"
            @toggle-select-all="toggleSelectAll"
            @visualizar-inconsistencias="visualizarInconsistencias"
            @historico-reprocessamento="historicoReprocessamento"
            @reprocessar="reprocessar"
            @download-json="downloadTxtJson"
          />
        </div>
      </div>
    </div>

    <InconsistenciasModal :inconsistencias="inconsistenciasData" :loading="loadingInconsistencias" @closed="onModalClosed" />
    <HistoricoReprocessamentoModal :historicoData="historicoReprocessamentoData" @closed="onHistoricoModalClosed" />
    <ConfirmacaoReprocessamentoModal
      :loading="loadingReprocessamento"
      @confirmar="confirmarReprocessamento"
      @cancelar="cancelarReprocessamento"
      @closed="onModalReprocessamentoClosed"
      ref="modalConfirmacaoReprocessamento"
    />
    <ReprocessamentoMassaModal
      :selectedCount="selectedCount"
      :loading="loadingReprocessamentoMassa"
      @confirmar="confirmarReprocessamentoMassa"
      @cancelar="cancelarReprocessamentoMassa"
      @closed="onModalReprocessamentoMassaClosed"
      ref="modalReprocessamentoMassa"
    />
    <ReprocessarTodosErroModal
      :contagemRegistrosComErro="contagemRegistrosComErro"
      :loading="loadingReprocessarTodosErro"
      @confirmar="confirmarReprocessarTodosErro"
      @cancelar="cancelarReprocessarTodosErro"
      @closed="onModalReprocessarTodosErroClosed"
      ref="modalReprocessarTodosErro"
    />
  </tour>
</template>

<script>
import PageHeader from '@/views/components/custom/page-header/PageHeader.vue';
import tourMixin from '@/mixins/tourMixin';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import InconsistenciasModal from '@/views/components/custom/modals/InconsistenciasModal.vue';
import HistoricoReprocessamentoModal from '@/views/components/custom/modals/HistoricoReprocessamentoModal.vue';
import ConfirmacaoReprocessamentoModal from '@/views/components/custom/modals/ConfirmacaoReprocessamentoModal.vue';
import ReprocessamentoMassaModal from '@/views/components/custom/modals/ReprocessamentoMassaModal.vue';
import ReprocessarTodosErroModal from '@/views/components/custom/modals/ReprocessarTodosErroModal.vue';
import IntegracaoRndsFiltros from './parts/IntegracaoRndsFiltros.vue';
import IntegracaoRndsTabela from './parts/IntegracaoRndsTabela.vue';
import IntegracaoRndsAcoes from './parts/IntegracaoRndsAcoes.vue';

export default {
  title: 'Logs e Reprocessamento',
  components: {
    PageHeader,
    InconsistenciasModal,
    HistoricoReprocessamentoModal,
    ConfirmacaoReprocessamentoModal,
    ReprocessamentoMassaModal,
    ReprocessarTodosErroModal,
    IntegracaoRndsFiltros,
    IntegracaoRndsTabela,
    IntegracaoRndsAcoes
  },
  mixins: [tourMixin],

  data() {
    return {
      linkItems: [
        { name: 'Integração RNDS', active: true },
        { name: 'Logs e Reprocessamento', active: true }
      ],
      search: {
        departamento: '', unidade: '', empresa: '', campanha: '', vacina: '',
        situacao: '', inconsistencias: '', dose: '', tipo_acao: '', inicio: '', final: '', colaborador: ''
      },
      loading: {
        departamento: false, unidade: false, empresa: false, campanha: false, vacina: false
      },
      departamentoSelect: [],
      unidadeSelect: [],
      empresaSelect: [],
      campanhaSelect: [],
      vacinaSelect: [],
      situacaoSelect: [
        { label: 'Todas', value: null },
        { label: 'Enviado', value: 'Enviado' },
        { label: 'Sucesso', value: 'Sucesso' },
        { label: 'Pendente', value: 'Pendente' },
        { label: 'Erro', value: 'Erro' },
        { label: 'Interrompido', value: 'Interrompido' }
      ],
      inconsistenciasSelect: [],
      dosesSelect: [],
      tipoAcaoSelect: [
        { label: 'Todas', value: null },
        { label: 'Envio', value: 'Envio' },
        { label: 'Cancelamento', value: 'Cancelamento' }
      ],
      loadingData: false,
      filtering: false,
      table: {
        items: [],
        optionsSize: [10, 25, 50, 100],
        columnOrder: '',
        sortDesc: false,
        order: 'asc'
      },
      paginationData: {
        currentPage: 1,
        defaultSize: 10,
        totalLines: 0,
        fromLine: 0,
        toLine: 0
      },
      selectAll: false,
      inconsistenciasData: null,
      loadingInconsistencias: false,
      historicoReprocessamentoData: [],
      contagemRegistrosComErro: 0,
      itemParaReprocessar: null,
      loadingReprocessamento: false,
      loadingReprocessamentoMassa: false,
      loadingReprocessarTodosErro: false,
    };
  },

  computed: {
    selectedCount() {
      return this.table.items.filter(item =>
        item.situacao === 'Erro' && item.selected === true
      ).length;
    }
  },

  mounted() {
    this.loadDepartamentos();
  },

  watch: {
    'search.campanha'(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        this.resetFiltersExcept(['departamento', 'campanha']);
        this.loadSelects();
      }
    },
    'search.departamento'(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        this.resetFiltersExcept(['departamento']);
        this.loadCampanhas();
        this.loadUnidades();
      }
    },
    'search.unidade'(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        this.search.empresa = '';
        this.loadEmpresas();
      }
    },
    'table.items': {
      handler() { this.updateSelectAllState(); },
      deep: true
    }
  },

  methods: {
    resetFiltersExcept(keep) {
      const defaults = { unidade: '', empresa: '', vacina: '', situacao: '', inconsistencias: '', dose: '', tipo_acao: '', inicio: '', final: '', colaborador: '' };
      if (!keep.includes('campanha')) defaults.campanha = '';
      Object.keys(defaults).forEach(k => { this.search[k] = defaults[k]; });
    },

    buildSearchParameters(additionalParams = {}) {
      const params = {
        id_departamento: this.search.departamento?.id_departamento || null,
        id_unidade: this.search.unidade?.id_unidade || null,
        id_empresa: this.search.empresa?.id_empresa || null,
        id_campanha: this.search.campanha?.id_campanha || null,
        id_vacina: this.search.vacina?.id_vacina || null,
        id_dose: this.search.dose?.value || null,
        tipo_acao: this.search.tipo_acao?.value || null,
        situacao: this.search.situacao?.value || null,
        id_inconsistencia: this.search.inconsistencias?.value || null,
        data_inicio: this.search.inicio || null,
        data_fim: this.search.final || null,
        nome_cpf: this.search.colaborador || null,
        coluna_ordenacao: this.table.columnOrder || null,
        ordem: this.table.order || null,
        ...additionalParams
      };
      Object.keys(params).forEach(k => { if (!params[k]) delete params[k]; });
      return params;
    },

    async loadSelects() {
      await Promise.all([this.loadCampanhas(), this.loadVacinas(), this.loadInconsistencias(), this.loadDoses()]);
    },

    async loadDepartamentos() {
      this.loading.departamento = true;
      try {
        const { data } = await this.$http.get(this.$api.getDepartamentosRnds());
        this.departamentoSelect = [{ descricao: 'Todas', id_departamento: null }, ...data.map(i => ({ descricao: i.descricao || i.nome_departamento, id_departamento: i.id_departamento }))];
      } finally { this.loading.departamento = false; }
    },

    async loadUnidades() {
      this.loading.unidade = true;
      try {
        const params = { id_campanha: this.search.campanha?.id_campanha, id_departamento: this.search.departamento?.id_departamento };
        const { data } = await this.$http.get(this.$api.getUnidadesRnds(), { params });
        this.unidadeSelect = [{ descricao: 'Todas', id_unidade: null }, ...data.map(i => ({ descricao: i.descricao || i.nome_unidade, id_unidade: i.id_unidade }))];
      } finally { this.loading.unidade = false; }
    },

    async loadEmpresas() {
      this.loading.empresa = true;
      try {
        const params = { id_campanha: this.search.campanha?.id_campanha, id_departamento: this.search.departamento?.id_departamento, id_unidade: this.search.unidade?.id_unidade };
        const { data } = await this.$http.get(this.$api.getEmpresasRnds(), { params });
        this.empresaSelect = [{ id_empresa: null, documento: '', nome_empresa: 'Todas' }, ...data.map(i => ({ ...i, nome_empresa: i.nome_empresa || i.razao_social }))];
      } finally { this.loading.empresa = false; }
    },

    async loadCampanhas() {
      this.loading.campanha = true;
      try {
        const params = { ativo: true, paginacao: false, colunaNome: 'termino_campanha', situacao: ['Em andamento', 'Concluída'] };
        if (this.search.departamento?.id_departamento) params.id_departamento = this.search.departamento.id_departamento;
        const { data } = await this.$http.get(this.$api.getCampanhasRnds(), { params });
        this.campanhaSelect = data.map(o => ({ descricao: o.descricao, id_campanha: o.id_campanha }));
      } finally { this.loading.campanha = false; }
    },

    async loadVacinas() {
      this.loading.vacina = true;
      try {
        if (this.search.campanha?.id_campanha) {
          const { data } = await this.$http.get(this.$api.getVacinasRnds(this.search.campanha.id_campanha));
          this.vacinaSelect = [{ descricao: 'Todas', id_vacina: null }, ...data.map(i => ({ descricao: i.nome_tecnico, id_vacina: i.id_vacina }))];
        } else { this.vacinaSelect = []; }
      } finally { this.loading.vacina = false; }
    },

    async loadInconsistencias() {
      try {
        const { data } = await this.$http.get(this.$api.getInconsistenciasRnds(this.search.campanha?.id_campanha));
        this.inconsistenciasSelect = [{ label: 'Todas', value: null }, ...data.map(i => ({ label: i.descricao, value: i.id_inconsistencia }))];
      } catch {}
    },

    async loadDoses() {
      try {
        const { data } = await this.$http.get(this.$api.getDosesRnds());
        this.dosesSelect = [{ label: 'Todas', value: null }, ...data.map(i => ({ label: i.descricao, value: i.id_dose }))];
      } catch {}
    },

    async loadContagemRegistrosComErro() {
      try {
        const params = this.buildSearchParameters({ situacao: 'Erro' });
        const { data } = await this.$http.get(this.$api.getIntegracaoRndsLogsComErro(), { params });
        const aplicacoesUnicas = new Set(data.map(item => item.id_aplicacao));
        this.contagemRegistrosComErro = aplicacoesUnicas.size;
      } catch { this.contagemRegistrosComErro = 0; }
    },

    async filterList() {
      this.filtering = true;
      try {
        const params = this.buildSearchParameters({ pagina: this.paginationData.currentPage, tamanho: this.paginationData.defaultSize });
        const { data } = await this.$http.get(this.$api.getIntegracaoRndsLogs(), { params });
        this.table.items = data.data || [];
        this.startPagination(data);
        await this.loadContagemRegistrosComErro();
      } catch {
        this.showToast('Erro', 'danger', 'Erro ao carregar os logs de integração RNDS');
      } finally { this.filtering = false; }
    },

    startPagination(data) {
      this.paginationData.currentPage = data.current_page;
      this.paginationData.totalLines = data.total;
      this.paginationData.fromLine = data.from;
      this.paginationData.toLine = data.to;
    },

    updateCurrentPage(page) {
      this.paginationData.currentPage = page;
      this.filterList();
    },

    async validateAndFilterList() {
      this.paginationData.currentPage = 1;
      const isValid = await this.$refs.filtrosComponent.validarFormulario();
      if (isValid) {
        this.filterList();
      }
    },

    async validateAndDownloadCSV() {
      const isValid = await this.$refs.filtrosComponent.validarFormulario();
      if (isValid) {
        this.downloadCSV();
      }
    },

    changePageSize(size) {
      this.paginationData.defaultSize = size;
      this.paginationData.currentPage = 1;
      this.filterList();
    },

    ordenarColuna(sort) {
      this.table.columnOrder = sort.sortBy;
      this.table.sortDesc = sort.sortDesc;
      this.table.order = sort.sortDesc ? 'desc' : 'asc';
      this.paginationData.currentPage = 1;
      this.filterList();
    },

    cleanSearch() {
      this.search = { departamento: '', unidade: '', empresa: '', campanha: '', vacina: '', situacao: '', inconsistencias: '', dose: '', tipo_acao: '', inicio: '', final: '', colaborador: '' };
      this.table.items = [];
      this.paginationData.totalLines = 0;
      this.paginationData.fromLine = 0;
      this.paginationData.toLine = 0;
      this.contagemRegistrosComErro = 0;
    },

    toggleSelectAll(val) {
      this.table.items.filter(i => i.situacao === 'Erro').forEach(i => { this.$set(i, 'selected', val); });
    },

    updateSelectAllState() {
      const erros = this.table.items.filter(i => i.situacao === 'Erro');
      this.selectAll = erros.length > 0 && erros.every(i => i.selected === true);
    },

    showToast(title, variant, text) {
      this.$toast({ component: ToastificationContent, props: { title, icon: variant === 'success' ? 'CheckIcon' : 'AlertTriangleIcon', variant, text } });
    },

    async executeReprocessing(idsAplicacao, successMessage) {
      await this.$http.post(this.$api.reprocessarIntegracaoRnds(), { id_aplicacao: idsAplicacao });
      this.showToast('Sucesso', 'success', successMessage);
      await this.filterList();
    },

    async downloadCSV() {
      try {
        const params = this.buildSearchParameters();
        const { data } = await this.$http.get(this.$api.exportarCSVIntegracaoRnds(), { params, responseType: 'blob' });
        const blob = new Blob([data], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = 'logs_integracao_rnds.csv';
        link.click();
        this.showToast('Sucesso', 'success', 'Download do CSV iniciado com sucesso');
      } catch { this.showToast('Erro', 'danger', 'Erro ao exportar o CSV'); }
    },

    async visualizarInconsistencias(item) {
      this.inconsistenciasData = null;
      this.loadingInconsistencias = true;
      this.$bvModal.show('modal-inconsistencias');
      
      try {
        const { data } = await this.$http.get(this.$api.getInconsistenciasPorIntegracao(item.id_integracao));
        this.inconsistenciasData = data.inconsistencias;
      } catch {
        this.showToast('Erro', 'danger', 'Erro ao carregar inconsistências');
        this.$bvModal.hide('modal-inconsistencias');
      } finally {
        this.loadingInconsistencias = false;
      }
    },

    historicoReprocessamento(item) {
      this.buscarHistoricoAplicacao(item);
    },

    async buscarHistoricoAplicacao(item) {
      try {
        const params = {};
        if (item.id_aplicacao_cancelamento) {
          params.id_aplicacao_cancelamento = item.id_aplicacao_cancelamento;
        }

        const { data } = await this.$http.get(
          this.$api.getHistoricoIntegracaoRnds(item.id_aplicacao),
          { params }
        );

        if (!data.historico || data.historico.length === 0) {
          this.showToast('Histórico', 'info', 'Nenhum histórico disponível');
          return;
        }

        this.historicoReprocessamentoData = data.historico;
        this.$bvModal.show('modal-historico-reprocessamento');
      } catch {
        this.showToast('Erro', 'danger', 'Erro ao carregar histórico');
      }
    },

    reprocessar(item) {
      this.itemParaReprocessar = item;
      this.$refs.modalConfirmacaoReprocessamento.show();
    },

    async confirmarReprocessamento() {
      if (!this.itemParaReprocessar?.id_aplicacao) return;
      this.loadingReprocessamento = true;
      try {
        await this.executeReprocessing([this.itemParaReprocessar.id_aplicacao], 'Registro enviado para reprocessamento');
        this.$refs.modalConfirmacaoReprocessamento.hide();
        this.itemParaReprocessar = null;
      } catch { this.showToast('Erro', 'danger', 'Erro ao reprocessar'); }
      finally { this.loadingReprocessamento = false; }
    },

    cancelarReprocessamento() { this.itemParaReprocessar = null; },
    onModalReprocessamentoClosed() { this.itemParaReprocessar = null; this.loadingReprocessamento = false; },
    onModalClosed() { this.inconsistenciasData = null; this.loadingInconsistencias = false; },
    onHistoricoModalClosed() { this.historicoReprocessamentoData = []; },

    reprocessarSelecionados() { this.$refs.modalReprocessamentoMassa.show(); },
    cancelarReprocessamentoMassa() {},
    onModalReprocessamentoMassaClosed() { this.loadingReprocessamentoMassa = false; },

    async confirmarReprocessamentoMassa() {
      const ids = this.table.items.filter(i => i.situacao === 'Erro' && i.selected).map(i => i.id_aplicacao).filter(Boolean);
      if (!ids.length) return;
      this.loadingReprocessamentoMassa = true;
      try {
        await this.executeReprocessing(ids, `${ids.length} registro(s) enviado(s) para reprocessamento`);
        this.$refs.modalReprocessamentoMassa.hide();
        this.table.items.forEach(i => { this.$set(i, 'selected', false); });
        this.selectAll = false;
      } catch { this.showToast('Erro', 'danger', 'Erro ao reprocessar selecionados'); }
      finally { this.loadingReprocessamentoMassa = false; }
    },

    reprocessarTodosComErro() { this.$refs.modalReprocessarTodosErro.show(); },
    cancelarReprocessarTodosErro() {},
    onModalReprocessarTodosErroClosed() { this.loadingReprocessarTodosErro = false; },

    async confirmarReprocessarTodosErro() {
      if (!this.contagemRegistrosComErro) return;
      this.loadingReprocessarTodosErro = true;
      try {
        const params = this.buildSearchParameters({ situacao: 'Erro' });
        const { data } = await this.$http.get(this.$api.getIntegracaoRndsLogsComErro(), { params });
        const ids = data.map(i => i.id_aplicacao).filter(Boolean);
        if (ids.length) {
          await this.executeReprocessing(ids, `${ids.length} registro(s) com erro enviado(s) para reprocessamento`);
          this.$refs.modalReprocessarTodosErro.hide();
        }
      } catch { this.showToast('Erro', 'danger', 'Erro ao reprocessar registros com erro'); }
      finally { this.loadingReprocessarTodosErro = false; }
    },

    downloadTxtJson(item) {
      this.downloadJsonFromHistorico(item);
    },

    async downloadJsonFromHistorico(item) {
      try {
        const params = {};
        if (item.id_aplicacao_cancelamento) {
          params.id_aplicacao_cancelamento = item.id_aplicacao_cancelamento;
        }

        const { data } = await this.$http.get(
          this.$api.getHistoricoIntegracaoRnds(item.id_aplicacao),
          { params }
        );

        if (!data.historico || data.historico.length === 0) {
          this.showToast('Erro', 'danger', 'Nenhum histórico disponível');
          return;
        }

        const hist = data.historico;
        const recent = hist.sort((a, b) => new Date(b.created_at || 0) - new Date(a.created_at || 0))[0];
        if (!recent.dados_enviados) {
          this.showToast('Erro', 'danger', 'Nenhum dado de envio disponível');
          return;
        }
        const dados = typeof recent.dados_enviados === 'string' ? JSON.parse(recent.dados_enviados) : recent.dados_enviados;
        const nome = (item.colaborador || item.pessoa_fisica_nome || 'colaborador').replace(/[^a-zA-Z0-9]/g, '_');
        const blob = new Blob([JSON.stringify(dados, null, 2)], { type: 'application/json' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = `dados_enviados_${nome}_${new Date().toISOString().split('T')[0]}.json`;
        link.click();
        this.showToast('Sucesso', 'success', 'Download iniciado');
      } catch {
        this.showToast('Erro', 'danger', 'Erro ao gerar arquivo JSON');
      }
    }
  }
};
</script>

<style>
.font_size_label { font-size: 15px; margin-top: -5px; }
.cor_botao { color: #2772C0 !important; border: 1px solid #2772C0 !important; }
</style>
